import React, { useState, useRef, useEffect } from "react";
import Paper from "@material-ui/core/Paper";
import Container from "@material-ui/core/Container";
import { makeStyles } from "@material-ui/core/styles";
import { formatDate } from "../CommonComponents/formatter";
// import ReportLayoutPage from "./ReportLayoutPage";
import LoadingComponent from "../CommonComponents/loadinComponent";
import moment from "moment";
import DataTable from "../UserManagement/SubUserManagement/Datatable";
import "../UserManagement/SubUserManagement/subUser.css";
import { TripsActionV2 } from "../../actions/TripsV2";
import { FaFilePdf } from "react-icons/fa";
import { FaFileExcel } from "react-icons/fa6";
import { Button } from "@material-ui/core";
import {
    Autocomplete as MuiAutocomplete,
    TextField as MuiTextField,
} from "@mui/material";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { LocksAction } from "../../actions/lock";
import DownloadIcon from "@mui/icons-material/Download";

import ReportFilter from "../ReportsGps/ReportFilter";
import ReportLayoutPage from "../ReportsGps/ReportLayoutPage";
import LockFilter from "./Lockfilter";

const getStatusColor = (status) => {
    const colorMap = {
        COMPLETED: "#4caf50",
        IN_PROGRESS: "#9a3412",
        INVALID: "#991b1b",
        PENDING: "#92400e",
        HALT: "#9d174d",
        MISSED: "#374151",
    };
    return colorMap[status] || "#374151";
};

const useStyles = makeStyles((theme) => ({
    customTooltip: {
        maxWidth: 320,
        backgroundColor: "#1e293b !important",
        color: "#ffffff !important",
    },
}));

const datePresetOptions = [
    { label: "Today", value: "today" },
    { label: "Yesterday", value: "yesterday" },
    { label: "This Week", value: "thisWeek" },
    { label: "Last Week", value: "lastWeek" },
    { label: "This Month", value: "thisMonth" },
    { label: "Last Month", value: "lastMonth" },
];

const Filter = ({
    setExportData,
    exportData,
    setItems,
    setLoading,
    setReportDates,
    extraActions,
    locks,
    locksLoading,
    page,
    rowsPerPage,
    setPage,
    setTotalCount,
}) => {
    const handleExport = async (type) => {
        const fromMoment = moment(from);
        const toMoment = moment(to);
        if (!exportData || exportData.length === 0) {
            alert("No data to export. Please generate a report first.");
            return;
        }
        const userData = JSON.parse(localStorage.getItem("data"));
        const payload = {
            fromDate: fromMoment.valueOf(),
            toDate: toMoment.valueOf(),
            companyId: userData?.companyId || 1,
            userId: userData?.id,
            usersId: 0,
            pageSize: null,
            lockId: lockFilter?.lockId || null,
            tripType: null,
            tripStatus: null,
            ForDashBoard: true,
            isExcelReport: type === "excel",
        };
        setLoading(true);
        try {
            const responseText = await TripsActionV2.exportLockTripsReport(payload, "SYSTEM_GENERATED");
            if (!responseText) {
                alert("Export failed. Please try again.");
                return;
            }
            let base64 = "";
            try {
                const json = JSON.parse(responseText);
                base64 = json?.data || json?.fileData || json?.base64 || json;
            } catch (e) {
                base64 = responseText;
            }
            if (typeof base64 !== "string" || base64.length < 10) {
                alert("Export failed: invalid file data received");
                return;
            }
            base64 = base64.replace(/^data:.*,/, "").replace(/\s/g, "");
            const mimeType = type === "excel"
                ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                : "application/pdf";
            const ext = type === "excel" ? "xlsx" : "pdf";
            try {
                const byteChars = atob(base64);
                const byteArr = new Uint8Array(byteChars.length);
                for (let i = 0; i < byteChars.length; i++)
                    byteArr[i] = byteChars.charCodeAt(i);
                const blob = new Blob([byteArr], { type: mimeType });
                const url = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = `SystemTrip_Report_${moment().format("YYYY-MM-DD_HH-mm")}.${ext}`;
                a.click();
                URL.revokeObjectURL(url);
            } catch (atobErr) {
                console.error("Base64 decoding error:", atobErr);
                alert("Export failed: could not decode file data.");
            }
        } catch (err) {
            console.error("Export error:", err);
            alert("Export failed. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const [from, setFrom] = useState(moment().startOf("day"));
    const [to, setTo] = useState(moment().endOf("day"));
    const [lockFilter, setLockFilter] = useState(null);
    const [datePreset, setDatePreset] = useState(datePresetOptions[0]);

    const filterRef = useRef({ from, to, lockFilter });
    useEffect(() => {
        filterRef.current = { from, to, lockFilter };
    }, [from, to, lockFilter]);

    const formatLatLon = (lat, lon) => {
        if (
            lat === undefined || lat === null ||
            lon === undefined || lon === null ||
            (lat === 0 && lon === 0)
        ) {
            return "—";
        }
        return `${Number(lat).toFixed(5)}, ${Number(lon).toFixed(5)}`;
    };

    const handleDatePresetChange = (option) => {
        setDatePreset(option);
        let selectedFrom, selectedTo;
        switch (option.value) {
            case "today":
                selectedFrom = moment().startOf("day");
                selectedTo = moment().endOf("day");
                break;
            case "yesterday":
                selectedFrom = moment().subtract(1, "day").startOf("day");
                selectedTo = moment().subtract(1, "day").endOf("day");
                break;
            case "thisWeek":
                selectedFrom = moment().startOf("week");
                selectedTo = moment().endOf("day");
                break;
            case "lastWeek":
                selectedFrom = moment().subtract(1, "week").startOf("week");
                selectedTo = moment().subtract(1, "week").endOf("week");
                break;
            case "thisMonth":
                selectedFrom = moment().startOf("month");
                selectedTo = moment().endOf("day");
                break;
            case "lastMonth":
                selectedFrom = moment().subtract(1, "month").startOf("month");
                selectedTo = moment().subtract(1, "month").endOf("month");
                break;
            default:
                return;
        }
        if (selectedTo.isBefore(selectedFrom)) {
            selectedTo = selectedFrom.clone().endOf("day");
        }
        setFrom(selectedFrom);
        setTo(selectedTo);
    };

    const fetchData = async (pageNo, pageSz, fromDate, toDate, lock) => {
        setLoading(true);
        const fromMoment = moment(fromDate);
        const toMoment = moment(toDate);

        if (toMoment.isBefore(fromMoment)) {
            alert("To Date cannot be less than From Date");
            setLoading(false);
            return;
        }

        if (toMoment.diff(fromMoment, "months", true) > 1) {
            alert("Date difference should not be more than 1 month");
            setLoading(false);
            return;
        }

        const userData = JSON.parse(localStorage.getItem("data"));

        const payload = {
            userId: userData?.id,
            gpsRefId: null,
            lockId: lock?.lockId || null,
            fromDate: fromMoment.valueOf(),
            toDate: toMoment.valueOf(),
            pageNo: pageNo,
            pageSize: pageSz,
        };

        try {
            const response = await TripsActionV2.getSystemTrips(payload);

            setReportDates({ from: fromDate, to: toDate });

            if (response?.data?.data && Array.isArray(response.data.data)) {
                const total = response.data.totalElements || response.data.data.length;
                setTotalCount(total);
                const mapped = response.data.data.map((trip, idx) => ({
                    id: pageNo * pageSz + idx + 1,
                    lockNumber: trip.lockNumber || "—",
                    serialNumber: trip.serialNumber || "—",
                    unlockMode: trip.unlockMode || "—",
                    vehicleNumber: trip.vehicleNumber || "—",
                    status: trip.status || "—",
                    tripStartTime: formatDate(trip.tripStartTime, "DD-MM-YYYY hh:mm A"),
                    tripEndTime: formatDate(trip.tripEndTime, "DD-MM-YYYY hh:mm A"),
                    distance:
                        trip.distance !== undefined && trip.distance !== null
                            ? `${(trip.distance/1000).toFixed(2)} km`
                            : "—",
                    startLocation: formatLatLon(trip.startLat, trip.startLon),
                    endLocation: formatLatLon(trip.endLat, trip.endLon),
                    startLat: trip.startLat,
                    startLon: trip.startLon,
                    endLat: trip.endLat,
                    endLon: trip.endLon,
                    raw: trip,
                }));
                setItems(mapped);
                setExportData(mapped);
            } else {
                setItems([]);
                setTotalCount(0);
            }
        } catch (err) {
            console.error("Error fetching system trip report:", err);
            setItems([]);
            setTotalCount(0);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = () => {
    if (!lockFilter) {
        alert("Please select a lock before generating the report.");
        return;
    }
        setPage(0);
        fetchData(0, rowsPerPage, from, to, lockFilter);
    };

    useEffect(() => {
        if (filterRef.current) {
        }
    }, []);

    const isFirstRender = useRef(true);
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        const { from: f, to: t, lockFilter: l } = filterRef.current;
        fetchData(page, rowsPerPage, f, t, l);
    }, [page, rowsPerPage]);

    return (
        <div style={{ padding: "16px", background: "#fff", borderRadius: "10px" }}>
            <div
                style={{
                    display: "flex",
                    gap: 12,
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "wrap",
                }}
            >
                {/* LEFT SECTION - Filters and Generate Button */}
                <div style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap" }}>
                    {/* Date Preset Dropdown */}
                    <MuiAutocomplete
                        size="small"
                        options={datePresetOptions}
                        value={datePreset}
                        getOptionLabel={(option) => option.label}
                        onChange={(e, newValue) => {
                            if (newValue) handleDatePresetChange(newValue);
                        }}
                        disableClearable
                        sx={{ width: 160 }}
                        renderInput={(params) => (
                            <MuiTextField
                                {...params}
                                placeholder="Today"
                                variant="outlined"
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        height: 40,
                                        borderRadius: "10px",
                                        backgroundColor: "#fff",
                                        fontSize: 13,
                                        "& fieldset": { borderColor: "#d1d5db" },
                                        "&:hover fieldset": { borderColor: "#9ca3af" },
                                        "&.Mui-focused fieldset": { borderColor: "#2563eb" },
                                    },
                                }}
                            />
                        )}
                    />

                    {/* From Date */}
                    <div>
                        <input
                            type="datetime-local"
                            value={from.format(moment.HTML5_FMT.DATETIME_LOCAL)}
                            onChange={(e) => setFrom(moment(e.target.value))}
                            style={{
                                padding: "8px 12px",
                                borderRadius: "8px",
                                border: "1px solid #d1d5db",
                                fontSize: 13,
                                width: 200,
                            }}
                        />
                    </div>

                    {/* To Date */}
                    <div>
                        <input
                            type="datetime-local"
                            value={to.format(moment.HTML5_FMT.DATETIME_LOCAL)}
                            onChange={(e) => setTo(moment(e.target.value))}
                            min={from.format(moment.HTML5_FMT.DATETIME_LOCAL)}
                            style={{
                                padding: "8px 12px",
                                borderRadius: "8px",
                                border: "1px solid #d1d5db",
                                fontSize: 13,
                                width: 200,
                            }}
                        />
                    </div>

                    {/* Lock Filter */}
                    <div style={{}}>
                        <LockFilter
                            locks={locks}
                            locksLoading={locksLoading}
                            lockFilter={lockFilter}
                            setLockFilter={setLockFilter}
                        />
                    </div>

                    {/* Generate Button */}
                    <Button
                        variant="contained"
                        style={{
                            borderRadius: 8,
                            height: 36,
                            minWidth: 100,
                            background: "#082D6B",
                            // marginLeft:10
                        }}
                        onClick={handleSubmit}
                    >
                        Show
                    </Button>
                </div>

                {/* RIGHT SECTION - Columns (extraActions), Excel, and PDF Export Buttons */}
                <div style={{ display: "flex", gap: 8, alignItems: "flex-end" }}>
                    {/* Columns button with dropdown - from extraActions */}
                    {extraActions}

                    {/* Excel Export Button */}
                    <Button
                        variant="contained"
                        startIcon={<FaFileExcel style={{ fontSize: 16 }} />}
                        endIcon={<DownloadIcon />}
                        onClick={() => handleExport("excel")}
                        style={{
                            height: 36,
                            padding: "0 16px",
                            background:
                                "linear-gradient(135deg, #064e3b 0%, #047857 100%)",
                            color: "#fff",
                            borderRadius: 8,
                            fontSize: 13,
                            fontWeight: 600,
                        }}
                    >
                        Excel
                    </Button>

                    {/* PDF Export Button */}
                    <Button
                        variant="contained"
                        startIcon={<FaFilePdf style={{ fontSize: 16 }} />}
                        endIcon={<DownloadIcon />}
                        onClick={() => handleExport("pdf")}
                        style={{
                            height: 36,
                            padding: "0 16px",
                            background:
                                "linear-gradient(135deg, #7f1d1d 0%, #b91c1c 100%)",
                            color: "#fff",
                            borderRadius: 8,
                            fontSize: 13,
                            fontWeight: 600,
                        }}
                    >
                        PDF
                    </Button>
                </div>
            </div>
        </div>
    );
};


const SystemGeneratedTripReport = (props) => {
    const classes = useStyles();
    const colSettingsKey = "system_trip_report_col_settings";

    const [items, setItems] = useState([]);
    const [isLoading, setLoading] = React.useState(false);
    const [exportData, setExportData] = React.useState([]);
    const [reportDates, setReportDates] = React.useState({
        from: null,
        to: null,
    });
    const [locks, setLocks] = useState([]);
    const [locksLoading, setLocksLoading] = useState(false);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [visibleColumns, setVisibleColumns] = useState(() => {
        const saved = localStorage.getItem(colSettingsKey);
        return saved
            ? JSON.parse(saved)
            : {
                id: true,
                lockNumber: true,
                serialNumber: true,
                unlockMode: true,
                vehicleNumber: true,
                status: true,
                tripStartTime: true,
                tripEndTime: true,
                distance: true,
                startLocation: true,
                endLocation: true,
            };
    });

    const [showColSettings, setShowColSettings] = useState(false);
    const colSettingsRef = useRef(null);

    useEffect(() => {
        const fetchLocks = async () => {
            try {
                setLocksLoading(true);
                const res = await LocksAction.getLockList({ pageNo: 0, pageSize: 0 });
                if (res.data && Array.isArray(res.data)) {
                    setLocks(res.data);
                }
            } catch (e) {
                console.error("Lock fetch error:", e);
            } finally {
                setLocksLoading(false);
            }
        };
        fetchLocks();
    }, []);

    const toggleColumn = (colId) => {
        setVisibleColumns((prev) => {
            const next = { ...prev, [colId]: !prev[colId] };
            localStorage.setItem(colSettingsKey, JSON.stringify(next));
            return next;
        });
    };

    useEffect(() => {
        const handler = (e) => {
            if (
                colSettingsRef.current &&
                !colSettingsRef.current.contains(e.target)
            ) {
                setShowColSettings(false);
            }
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    const allColumns = [
        { id: "id", label: "S. No." },
        { id: "lockNumber", label: "Lock Number" },
        { id: "serialNumber", label: "Serial Number" },
        { id: "unlockMode", label: "Unlock Mode" },
        { id: "vehicleNumber", label: "Vehicle Number" },
        {
          id: "status",
          label: "Status",
           render: (row) => (
            <span style={{ color: getStatusColor(row.status), fontWeight: 600 }}>
                 {row.status.charAt(0).toUpperCase() + row.status.slice(1).toLowerCase()}
            </span>
        ),
        },
        { id: "tripStartTime", label: "Start Time" },
        { id: "tripEndTime", label: "End Time" },
        { id: "distance", label: "Approx Distance" },
        { id: "startLocation", label: "Start Location" },
        { id: "endLocation", label: "End Location" },
    ];
    const columns = allColumns.filter((col) => visibleColumns[col.id]);

    return (
        <div className="sub-user-list-root" style={{ position: "relative" }}>
            <LoadingComponent isLoading={isLoading} />
            <div className="page-title-row" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 20 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                    <button className="page-back-btn" onClick={() => window.open("/stats-dashboard", "_self")} aria-label="Go back">
                        <ArrowBackIcon className="page-back-icon" />
                    </button>
                    <span className="page-title-text">Digital Lock Trips-System Generated</span>
                </div>

            </div>

            <Container style={{}}>
                <ReportLayoutPage
                    filter={
                        <Filter
                            setExportData={setExportData}
                            exportData={exportData}
                            setLoading={setLoading}
                            setItems={setItems}
                            setReportDates={setReportDates}
                            locks={locks}
                            locksLoading={locksLoading}
                            page={page}
                            rowsPerPage={rowsPerPage}
                            setPage={setPage}
                            setTotalCount={setTotalCount}
                            extraActions={
                                <div className="gf-col-settings-wrap" ref={colSettingsRef}>
                                    <button
                                        className={`gf-col-settings-btn ${showColSettings ? "active" : ""
                                            }`}
                                        onClick={() => setShowColSettings(!showColSettings)}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 6,
                                            height: 40,
                                            padding: "0 16px",
                                            border: "none",
                                            borderRadius: 10,
                                            background: showColSettings
                                                ? "linear-gradient(135deg, #0f172a 0%, #1e293b 30%, #334155 60%, #475569 100%)"
                                                : "linear-gradient(135deg, #1e293b 0%, #334155 30%, #475569 60%, #64748b 100%)",
                                            color: "#ffffff",
                                            fontSize: 14,
                                            fontWeight: 600,
                                            cursor: "pointer",
                                            boxShadow: showColSettings
                                                ? "0 6px 24px rgba(30, 41, 59, 0.55)"
                                                : "0 4px 16px rgba(30, 41, 59, 0.4)",
                                            letterSpacing: "0.3px",
                                            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                                            transform: showColSettings ? "translateY(-1px)" : "translateY(0)",
                                        }}
                                    >
                                        <svg
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                            width="16"
                                            height="16"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                        Columns
                                    </button>
                                    {showColSettings && (
                                        <div className="gf-col-dropdown">
                                            <div className="gf-col-dropdown-header">
                                                Toggle Columns
                                            </div>
                                            {allColumns.map((col) => (
                                                <label key={col.id} className="gf-col-dropdown-item">
                                                    <input
                                                        type="checkbox"
                                                        className="gf-col-checkbox"
                                                        checked={!!visibleColumns[col.id]}
                                                        onChange={() => toggleColumn(col.id)}
                                                    />
                                                    {col.label}
                                                </label>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            }

                        />
                    }
                >
                    <Paper className="sub-user-list-paper">
                        <DataTable
                            columns={columns}
                            rows={items || []}
                            rowKey={(row) => row.id}
                            tableId="system-trip-report-table"
                            page={page}
                            rowsPerPage={rowsPerPage}
                            totalCount={totalCount}
                            onPageChange={(e, newPage) => setPage(newPage)}
                            onRowsPerPageChange={(e) => {
                                setRowsPerPage(parseInt(e.target.value, 10));
                                setPage(0);
                            }}
                            rowsPerPageOptions={[10, 25, 50, 100]}
                            emptyState={
                                <div style={{ textAlign: "center", padding: "4rem 2rem" }}>
                                    <div style={{ fontSize: "48px", color: "#bdbdbd" }}>📋</div>
                                    <div
                                        style={{
                                            color: "#757575",
                                            fontSize: "18px",
                                            fontWeight: 500,
                                        }}
                                    >
                                        No system-generated trip data
                                    </div>
                                    <div
                                        style={{
                                            color: "#9e9e9e",
                                            fontSize: "14px",
                                            marginTop: "4px",
                                        }}
                                    >
                                        Select a lock and date range, then click Generate
                                    </div>
                                </div>
                            }
                            showRowMenu={false}
                        />
                    </Paper>
                </ReportLayoutPage>
            </Container>
        </div>
    );
};

export default SystemGeneratedTripReport;